module.exports = __webpack_public_path__ + "static/media/logo_connections.819f560a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_connections.png
// module id = 470
// module chunks = 1